// extracted by mini-css-extract-plugin
module.exports = {"host":"vm-theme_host__sbAO1"};